import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExamRegisteredStudentsModel, ExamRegisteredStudentsRegularModel } from '../../models/exams/examination-models';

@Injectable({
  providedIn: 'root'
})
export class StudentExamsService {

  private baseUrl = environment.apiUrl + '/api/Exam'

  constructor(private http: HttpClient) { }

  examRegisterStudentsList(branchId: string): Observable<ExamRegisteredStudentsModel[]>{
    return this.http.get<ExamRegisteredStudentsModel[]>(`${this.baseUrl}/exam/register/${branchId}`)
  }

  examRegisterStudentsRegularList(branchId: string): Observable<ExamRegisteredStudentsRegularModel[]>{
    return this.http.get<ExamRegisteredStudentsRegularModel[]>(`${this.baseUrl}/exam/register/regular/${branchId}`)
  }

}
